import React from "react";

export const mediaBlockRenderer = block => {
	if (block.getType() === "atomic") {
		return {
			component: Media,
			editable: false
		};
	}

	return null;
};

const Image = props => {
	if (!!props.src) {
	return <div style={{textAlign: 'center'}}><img style={{maxWidth: 600}} src={props.src} alt={props.alt} width="100%" height="auto" />{props.note && <p><em>{props.note}</em></p>}</div>;
	}
	return null;
};
const Youtube = props => {
	if (!!props.id) {
		return <iframe id={props.id} title={props.id} width={props.width} height={props.height} src={`https://www.youtube.com/embed/${props.id}`} frameBorder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowFullScreen />;
	}
	return null;
};

const Media = props => {
	const entity = props.contentState.getEntity(props.block.getEntityAt(0));
	const { src, alt, note, width, height, id } = entity.getData();
	const type = entity.getType();

	let media;

	if (type === "image") {
		media = <Image src={src} alt={alt} note={note} />;
	} else if (type === "youtube") {
		media = <Youtube id={id} width={width} height={height} />;
	}
	

	return media;
};
